import React,{ Component, Fragment } from "react";
import RightArrow from 'assets/btn-right-arrow-new.png';
import InputValidation from 'components/InputValidation';
import RadioInputNew from '../../components/RadioInput/indexnew';

class OrderSummary extends Component{
    constructor(props) {
        super(props);
        this.state={
            couponCode:this.props.couponCode || '',
            cutlery:this.props.cutlery || '',
            paymentMethod:this.props.paymentMethod || '',
            bag_price:this.props.bag_price || 180,
        };
    }

    renderContent = (title,content) =>{
        return <div className="summary-label-con">
        <p className='summary-label'>{title}</p>
        <h6>{content}</h6>
     </div>
    }
    displayPirce =(price)=>{
        return (price/100) + ' AED';
    }
    onChange = (name,val)=>{
        const { changeParams } = this.props;
        if(changeParams!=undefined){
           this.setState({[name]:val},changeParams(name,val));
        }else{
            this.setState({[name]:val});
        }
    }
    componentWillReceiveProps(next) {
        if(this.state.couponCode != next.couponCode) {
            this.setState({couponCode:next.couponCode});
        }
      }
    render(){ 
        const {  addOnList, subTotal,mealPrice, addPrice, totalPrice, days_count, priceDatas,paymentOption,  applyClick, savePlan, checkoutId, bagPriceOption, mealTypeList, couponError, cutleryDatas } = this.props;
        const { couponCode, cutlery, paymentMethod, bag_price } = this.state;
        const { couponCode:applyCoupon, discountPrice, discountPer, discountType,discountTypeCoupon:couponType,discountPriceCoupon:couponDiscount, discountPerCoupon:couponPerDiscount } = priceDatas;
        const buttonText = checkoutId?'Proceed to Pay':'Save & Proceed to Edit Menu';
        return <div className="summary-container">
        <div className="summary-con-left">
           <h2>Order Summary</h2>
           <div class="summary-label-head"><p class="summary-label">Plan & Days</p><h6>{'Custom fit - '+days_count+" Days"}</h6><div></div></div>
            {this.renderContent('Meals',mealTypeList.join(' , ')+" : "+(this.displayPirce(mealPrice)))}
            {addOnList.length>0 ? this.renderContent('Add-ons',addOnList.join(' , ')+' '+this.displayPirce(addPrice/days_count)+' x '+days_count+' Days ='+this.displayPirce(addPrice)):this.renderContent('Add-ons','None')}
            {this.renderContent('Sub Total',this.displayPirce(subTotal))}
       </div>
       <div className="summary-con-right">
            <div className="summary-con-right-sticky">
            <div className='coupon-code-con'>
            <h2>Coupon Code or Voucher</h2>
                <InputValidation
                  name='couponCode'
                  value={couponCode}
                  onChange={this.onChange}
                  placeholder='Enter voucher code'
                  errors={couponError}
                  inputSelfClassName='standart-input b-rounded-blue'
                />
                 <div className="btn--con"><div className='button-small transition continue' onClick={() => { applyClick(couponCode); }}><span>Apply</span></div></div>
                 {applyCoupon && <p>Your Coupon Code is Applied</p>}
              </div>
             
                <div className="priceDetails">
                  <div className="price-con">
                    <div className="price-con-left">
                    <label>Sub Total</label>
                    {discountPer>0 &&<div className="price-discount">{this.displayPirce(subTotal)} - {discountPer}{discountType=='percent'?'% OFF':' AED'} </div>}
                    {couponPerDiscount>0 &&<div className="price-discount">{this.displayPirce(discountPrice>0?discountPrice:subTotal)} - {couponPerDiscount}{couponType=='percent'?'% OFF':''} </div>}
                    </div>
                    <div className="price-con-right">
                      {couponDiscount > 0 && (discountPrice>0 || discountPrice<=0) && this.displayPirce(couponDiscount)}
                      {discountPer>0 && (couponDiscount<=0||couponDiscount==undefined ) && this.displayPirce(discountPrice)}
                      {discountPer<=0 && (couponPerDiscount<=0||couponPerDiscount==undefined) && this.displayPirce(subTotal)}
                      </div>
                  </div>
                </div>
                <div className="cutlery-con">
                  <RadioInputNew name='cutlery' label={'Cutlery'} datas={cutleryDatas} value={cutlery} onChange={this.onChange} />
                </div>
                <div className="bag-con">
                  <RadioInputNew name='bag_price' label={''} datas={bagPriceOption} isHorizontal={true} value={bag_price} onChange={this.onChange} />
                </div>
                            
            </div>
            <div className="checkout-section">
              <div className="totalPrice">
                <div className="totalPriceGrid">
                  <div className="totalPriceLeft">  
                      <strong>Total Payable</strong>                      
                  </div>
                  <div className="totalPriceRight">
                    {this.displayPirce(totalPrice)}
                  </div>
                </div>                  
                <p>Price inclusive of delivery charges  taxes</p>
                </div>
                {checkoutId &&<div className="">
                   <RadioInputNew name='paymentMethod' label={'Payment Method'} datas={paymentOption} isHorizontal={true} value={paymentMethod} onChange={this.onChange} />
                </div>}    
            </div>
            <div className="btn-con">
              <div className='button-small transition continue' onClick={() => { savePlan(checkoutId); }}>
                <span>{buttonText}</span> 
                <strong>{this.displayPirce(totalPrice)}</strong>
                {checkoutId &&<span className="icon"><img src={RightArrow} /></span>}
              </div>
            </div>
           
       </div>
       </div>
    }
}
export default OrderSummary;